import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { FormControl, ReactiveFormsModule, ValidatorFn, Validators } from '@angular/forms';
import { AsButtonDirective } from '@directives/as-button/as-button.directive';
import {
  NgbDateAdapter,
  NgbDateParserFormatter,
  NgbDateStruct,
  NgbDatepickerModule
} from '@ng-bootstrap/ng-bootstrap';
import { TranslationPipe } from '@pipes/translation/translation.pipe';
import { CustomAdapter, CustomDateParserFormatter } from '@utils/custom-form.utils';
import { Subscription } from 'rxjs';
import { DomSanitizerPipe } from 'tangoe-design-system';

export const DATE_PATTERN = /^(0?[1-9]|1[0-2])\/(0?[1-9]|1\d|2\d|3[01])\/(\d{4})$/;

@Component({
  selector: 'ts-date-picker',
  templateUrl: './date-picker.component.html',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgbDatepickerModule,
    AsButtonDirective,
    DomSanitizerPipe,
    TranslationPipe
  ],
  providers: [
    { provide: NgbDateAdapter, useClass: CustomAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter }
  ]
})
export class DatePickerComponent implements OnInit, OnChanges, OnDestroy {
  @Input() id: string;
  @Input() label: string;
  @Input() name: string;
  @Input() control: FormControl;
  @Input() required: boolean = false;
  @Input() header_text?: string;
  @Input() help_text?: string;
  @Input() validate_pattern?: boolean = true;
  @Input() min_date: NgbDateStruct;
  @Input() max_date: NgbDateStruct;
  @Input() errors: { [k: string]: string };
  date_validator: ValidatorFn = Validators.pattern(DATE_PATTERN);
  private subscriptions: Subscription = new Subscription();

  ngOnInit(): void {
    this.subscriptions.add(
      this.control.valueChanges.subscribe((val: any) => {
        if (!this.control.value && !this.required) this.control.setErrors(null);
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['control'] || changes['validate_pattern']) {
      if (!this.validate_pattern) {
        this.control.removeValidators(this.date_validator);
        this.control.setErrors(null);
        return;
      }

      this.control.addValidators(this.date_validator);
      this.control.updateValueAndValidity();
    }
  }
}
